export const LEADERS = [
  {
    id: 0,
    name: 'Peter Pan',
    image: '/assets/images/alberto.png',
    designation: 'Chief Epicurious Officer',
    abbr: 'CEO',
    featured: false,
    description: "Our CEO, Peter, credits his hardworking East Asian immigrant parents who undertook the arduous journey to the shores of America with the intention of giving their children the best future. His mother's wizardy in the kitchen whipping up the tastiest dishes with whatever is available inexpensively at the supermarket, was his first inspiration to create the fusion cuisines for which The Frying Pan became well known. He brings his zeal for fusion cuisines to this restaurant, pioneering cross-cultural culinary connections."
  },
  {
    id: 1,
    name: 'Dhanasekaran Witherspoon',
    image: '/assets/images/alberto.png',
    designation: 'Chief Food Officer',
    abbr: 'CFO',
    featured: false,
    description: 'Our CFO, Danny, as he is affectionately referred to by his colleagues, comes from a long established family tradition in farming and produce. His experiences growing up on a farm in the Australian outback gave him great appreciation for varieties of food sources. As he puts it in his own words, Everything that runs, wins, and everything that stays, pays!'
  },
  {
    id: 2,
    name: '车管家小程序',
    image: '/assets/images/alberto.png',
    designation: 'Chief Taste Officer',
    abbr: 'CTO',
    featured: false,
    description: 'Blessed with the most discerning gustatory sense, Agumbe, our CFO, personally ensures that every dish that we serve meets his exacting tastes. Our chefs dread the tongue lashing that ensues if their dish does not meet his exacting standards. He lives by his motto, You click only if you survive my lick.'
  },
  {
    section: "团队",
    id: 3,
    name: 'Lee',
    image: '/assets/images/lee.jpg',
    designation: '全栈工程师',
    abbr: '创始人',
    featured: true,
    description: '2011年毕业于南昌大学，目前就职于中国移动苏州研发中心。负责公司云平台的前端架构和开发工作。'
  }
];